import type { ApiClient } from './types'
import { httpClient } from './httpClient'
import { mockClient } from './mockClient'

export const IS_MOCK = import.meta.env.VITE_MOCK === '1'

export const api: ApiClient = IS_MOCK ? mockClient : httpClient

export type { ApiClient, OverlayRenderResult, UploadProgress } from './types'
